import React from 'react';
import { useMsal } from '@azure/msal-react';
import { performLocalLogout } from './msalConfig';
import './NotAuthorized.css';

const TenantNotAllowed: React.FC = () => {
  const { instance } = useMsal();

  const handleSignOut = () => {
    // Perform local logout without showing Microsoft account picker
    performLocalLogout(instance);
  };

  return (
    <div className="not-authorized-outer">
      <div className="not-authorized-card">
        <img src="/hilco-vision-full-logo.png" alt="Hilco Vision Logo" className="not-authorized-logo" />
        <h2 className="not-authorized-title">Access Denied</h2>
        <p className="not-authorized-desc">
          Your organization is not authorized to access this application.
          Please contact your administrator if you believe this is an error.
        </p>
        <button
          onClick={handleSignOut}
          className="not-authorized-btn"
          style={{ cursor: 'pointer' }}
        >
          Sign Out
        </button>
      </div>
    </div>
  );
};

export default TenantNotAllowed;
